import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Link } from './LocalizedLink';
import { stripLang } from '../i18n/langs';
import { Phone, Menu, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import Logo from './Logo';
import LanguageSelector from './LanguageSelector';
import { logEvent } from '../lib/analytics';

const Navbar: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const location = useLocation();
  const { t } = useTranslation();

  const navigation = [
    { name: t('nav.emergencies'), href: '/emergency-repairs' },
    { name: t('nav.installations'), href: '/electrical-installations' },
    { name: t('nav.inspections'), href: '/safety-inspections' },
    { name: t('nav.maintenance'), href: '/maintenance' },
    { name: t('nav.cie'), href: '/cie' },
    { name: t('nav.brie'), href: '/brie' },
    { name: t('nav.blog'), href: '/blog' },
  ];

  const isActive = (path: string) => stripLang(location.pathname) === path;

  const handleNavClick = () => {
    if (isMenuOpen) {
      setIsClosing(true);
      setTimeout(() => {
        setIsMenuOpen(false);
        setIsClosing(false);
      }, 500);
    }
  };

  const handleMenuToggle = () => {
    if (isMenuOpen) {
      setIsClosing(true);
      setTimeout(() => {
        setIsMenuOpen(false);
        setIsClosing(false);
      }, 500);
    } else {
      setIsMenuOpen(true);
    }
  };

  const handleCallClick = () => {
    logEvent('Contact', 'Click', 'Navbar Call Button');
  };

  return (
    <nav className="bg-black text-white">
      <div className="container mx-auto px-4">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between py-4">
          <div className="flex justify-between items-center">
            <div className="flex items-center gap-4">
              <Link to="/" aria-label="Inicio" onClick={handleNavClick}>
                <Logo />
              </Link>
              <LanguageSelector />
            </div>
            <div className="flex items-center gap-4 lg:hidden">
              <button
                onClick={handleMenuToggle}
                className="text-white hover:text-yellow-500 transition-colors"
              >
                {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
              </button>
            </div>
          </div>

          <div 
            className={`lg:flex flex-col lg:flex-row lg:items-center lg:space-x-8 transition-all duration-500 ease-in-out transform ${
              isMenuOpen ? 'flex opacity-100 translate-y-0 max-h-[1000px]' : 'hidden lg:flex opacity-0 lg:opacity-100 -translate-y-4 lg:translate-y-0 max-h-0 lg:max-h-none'
            } ${isClosing ? 'opacity-0 -translate-y-4 max-h-0' : ''}`}
          >
            <div className="flex flex-col lg:flex-row lg:items-center lg:space-x-6 space-y-4 lg:space-y-0 mt-4 lg:mt-0">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  onClick={handleNavClick}
                  className={`transition-colors hover:text-yellow-500 ${
                    isActive(item.href) ? 'text-yellow-500' : ''
                  }`}
                >
                  {item.name}
                </Link>
              ))}
            </div>
            <div className="flex items-center gap-4 mt-4 lg:mt-0">
              <a
                href="tel:+34600238283"
                onClick={handleCallClick}
                className="btn-primary flex items-center justify-center gap-2"
              >
                <Phone className="w-5 h-5" />
                +34 600 23 82 83
              </a>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;